import React, { useRef, useEffect } from "react"
import styled from "styled-components"
import { FaChevronDown, FaSoundcloud } from "react-icons/fa"
import { usePlayer } from "./PlayerContext"

const PersistentPlayer = () => {
  const { showPlayer, togglePlayerVisibility } = usePlayer()
  const iframeRef = useRef(null)

  useEffect(() => {
    // Only load iframe once
    if (iframeRef.current && iframeRef.current.src === "") {
      iframeRef.current.src =
        "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2104165098&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
    }
  }, [])

  return (
    <PlayerWrapper $visible={showPlayer}>
      <ToggleTab onClick={togglePlayerVisibility}>
        {showPlayer ? (
          <>
            <FaChevronDown className="tab-icon" />
            <span>Minimize</span>
          </>
        ) : (
          <>
            <FaSoundcloud className="tab-icon tab-icon--soundcloud" />
            <span>Now Playing</span>
          </>
        )}
      </ToggleTab>
      <div className="player-content">
        <iframe
          ref={iframeRef}
          title="Summer Breeze Mixtape 002"
          width="100%"
          height="100%"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2104165098&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
        />
      </div>
    </PlayerWrapper>
  )
}

const PlayerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: ${(props) => (props.$visible ? "100%" : "auto")};
  max-width: 400px;
  background: #0a0a0a;
  border-radius: 0 12px 0 0;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.6);
  border-top: ${(props) =>
    props.$visible ? "1px solid rgba(255,255,255,0.1)" : "none"};
  overflow: hidden;
  z-index: 10000;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .player-content {
    width: ${(props) => (props.$visible ? "100%" : "auto")};
    height: ${(props) => (props.$visible ? "100%" : "0")};
    aspect-ratio: 1 / 1;
    overflow: hidden;
    opacity: ${(props) => (props.$visible ? "1" : "0")};
    visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
    pointer-events: ${(props) => (props.$visible ? "auto" : "none")};
    transform: ${(props) =>
      props.$visible ? "translateY(0)" : "translateY(8px)"};
    transition: opacity var(--transition-med, 300ms ease),
      transform var(--transition-med, 300ms ease),
      visibility var(--transition-med, 300ms ease),
      height var(--transition-med, 300ms ease);
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  @media (max-width: 768px) {
    width: ${(props) => (props.$visible ? "75vw" : "auto")};
    max-width: ${(props) => (props.$visible ? "75vw" : "auto")};

    .player-content {
      width: ${(props) => (props.$visible ? "75vw" : "auto")};
      aspect-ratio: 5 / 3;
    }
  }
`

const ToggleTab = styled.button`
  padding: 10px 16px;
  border-radius: 0 10px 0 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-bottom: none;
  background: #0a0a0a;
  color: var(--primary);
  cursor: pointer;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  transition: background var(--transition-fast, 200ms ease),
    border-color 200ms ease;

  .tab-icon {
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
  }

  .tab-icon--soundcloud {
    color: var(--primary);
    font-size: 18px;
  }

  span {
    margin-bottom: 2px;
  }

  &:hover {
    background: #141414;
    border-color: var(--primary);
  }

  @media (max-width: 768px) {
    font-size: 11px;
  }
`

export default PersistentPlayer
